import { render, staticRenderFns } from "./imagensEditar.vue?vue&type=template&id=2e212dd5&scoped=true&"
import script from "./imagensEditar.vue?vue&type=script&lang=js&"
export * from "./imagensEditar.vue?vue&type=script&lang=js&"
import style0 from "./imagensEditar.vue?vue&type=style&index=0&id=2e212dd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e212dd5",
  null
  
)

export default component.exports